import type { AxiosError } from 'axios';
import { useMutation, useQuery } from '@tanstack/react-query';

import { api } from '../client';
import {
  CustomLibraryDocument,
  GetLibrarySlugReq,
  GetLibrarySlugRes,
  GetRetrievalBundlesRes,
} from '../types/';
import React from 'react';
import { UserContext } from '../context/userContext';
import { enqueueSnackbar } from 'notistack';

const getRetrievalBundles = () => {
  return api.get<AxiosError, GetRetrievalBundlesRes>('/v1/retrieval-bundles');
};

const getLibrarySlug = ({ slug }: GetLibrarySlugReq) => {
  return api.get<AxiosError, GetLibrarySlugRes>(`/v1/library/${slug}`);
};

export const libraryService = () => {
  const { loggedIn } = React.useContext(UserContext);

  const retrievalBundles = useQuery({
    queryKey: ['getRetrievalBundles'],
    queryFn: getRetrievalBundles,
    enabled: loggedIn,
  });

  const librarySlugMutation = useMutation({
    mutationFn: getLibrarySlug,
    onError: ({ message }) => {
      enqueueSnackbar(`getLibrarySlug error: ${message}`, {
        variant: 'error',
      });
    },
    onSuccess: () => {},
  });

  const libraryDocuments =
    librarySlugMutation.data?.data.libraries?.[0].library.docs || {};

  return {
    retrievalBundlesTagsList: retrievalBundles.data?.data.retrieval_bundles.map(
      ({ slug, library }) => ({ slug, name: library.name }),
    ),
    libraryTagList: retrievalBundles.data?.data.retrieval_bundles.map(
      ({ library: { name, slug } }) => ({ slug, name }),
    ),
    getLibraries: librarySlugMutation.mutate,
    // hack to get an array
    libraryList: Object.keys(libraryDocuments).map((k) => ({
      ...libraryDocuments[k],
      id: libraryDocuments[k].uc_doc_id,
    })) as CustomLibraryDocument[] | null[],
  };
};
